import type { PackType } from '@/lib/api/packs/packs-api'
import type { ReactNode } from 'react'
import { MdAutoAwesome, MdReceipt, MdVideoCall } from 'react-icons/md'

/** Produto vendido por pacote na Loja do Sistema. */
export interface PackProduct {
    type: PackType
    title: string
    description: string
    /** Unidade no plural, para "1.000 créditos", "50 atendimentos". */
    unit: string
    icon: ReactNode
    /** Menor quantidade do pacote personalizado. */
    minCustomQuantity: number
}

/**
 * Ordem da vitrine. Quem aparece para cada conta (segmento, pessoa física,
 * plano ilimitado) é decidido na página, com os dados de consumo do plano.
 * Teleconsulta continua fora: o recurso está desativado para todas as contas.
 */
export const PACK_PRODUCTS: PackProduct[] = [
    {
        type: 'ai-credits',
        title: 'Créditos de IA',
        description:
            'Usados pelo atendente virtual do WhatsApp, pelos assistentes, pela leitura de comprovantes e pelos demais recursos de inteligência artificial. Cada uso desconta créditos conforme o tamanho da tarefa.',
        unit: 'créditos',
        icon: <MdAutoAwesome className="text-xl" />,
        minCustomQuantity: 1000,
    },
    {
        type: 'video-credits',
        title: 'Créditos de vídeo',
        description:
            'Minutos de videoconferência além do que o plano inclui no mês. Cada crédito vale um minuto por participante com vídeo; quem só assiste usa menos. Valem 12 meses.',
        unit: 'minutos',
        icon: <MdVideoCall className="text-xl" />,
        minCustomQuantity: 1000,
    },
    {
        type: 'fiscal-notes',
        title: 'Notas fiscais extras',
        description:
            'Notas fiscais além do que o plano inclui no mês. Valem no mês da compra.',
        unit: 'notas',
        icon: <MdReceipt className="text-xl" />,
        minCustomQuantity: 50,
    },
]
